import gql from 'graphql-tag'
import { COURSE_FIELDS } from '../../course/gql/fragments'

export const SELF_ATTESTABLE_PSI_COURSES_QUERY = gql`
    query SelfAttestablePsiCourses($projectId: ID!) {
        selfAttestablePsiCourses(projectId: $projectId) {
            ...CourseFields
            myNonExpiredCompletionsForProject(projectId: $projectId) {
                canDelete
                id
                updatedAt
                ... on SelfAttestedCourseCompletion {
                    canDelete
                    id
                    updatedAt
                    course {
                        ...CourseFields
                    }
                }
            }
        }
    }
    ${COURSE_FIELDS}
`
